import { render } from "./PDeleteBlock.vue?vue&type=template&id=18e5352e"
import script from "./PDeleteBlock.vue?vue&type=script&lang=js"
export * from "./PDeleteBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__